import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {StatusPipe} from "../../pipes/status.pipe";

@Component({
    selector: 'app-reminder',
    templateUrl: './reminder.component.html',
    imports: [
        NgForOf,
        NgIf,
        RouterLink,
        DatePipe,
        StatusPipe
    ],
    styleUrl: './reminder.component.scss'
})
export class ReminderComponent implements OnInit {

    private dataService = inject(DataService);

    departments: any[];

    ngOnInit(): void {
        this.dataService.request('Task/listByReminderDate').subscribe(response => {
            this.departments = response.departments;
        });
    }

}
